import {until} from 'lit-html/directives/until';
import '../dropdown';

const renderGroup = (group, groupIndex, ctx, html) => html`
<ems-dropdown class="full-width w-100 mb-3" ?disabled="${ctx.disabled}">
  <button type="button" slot="dropdown-toggle" class="btn btn-outline-light form-control d-flex justify-content-between"  ?disabled="${ctx.disabled}">
    <span class="mr-4 text-truncate">${group.label === ''? html`${until(ctx.__('<tt-+lDhnTa5>', 'Select', 'Select Region, Select District, ...'))} ${until(group.tier)}`: html`${group.label}`}</span>
    <span class="ai ai-chevron-down"></span>
  </button>
  <div slot="dropdown-menu" class="dropdown-menu m-0 w-100" @click="${(e) => ctx.maxLevel === group.level && e.stopPropagation()}">
    ${group.groups.map((item, itemIndex) => html`
      <button type="button" class="btn dropdown-item text-truncate ${ctx.selected.indexOf(item.id) !== -1? 'disabled': ''}" @click="${(e) => ctx.selectGroup(groupIndex, itemIndex)}" ?disabled="${ctx.disabled}">${item.name}</button>
    `)}
    </div>
</ems-dropdown>
`;
export default (ctx, html) => html`
${ctx.groups.map((group, index) => renderGroup(group, index, ctx, html))}
`;
